export enum ZoomLevel
{
    World = 1,
    LandmassOrContinent = 5,
    City = 10,
    Streets = 15,
    Buildings = 20
}
